import {useCustomQuery} from "@/global/hooks/useCustomQuery";
import {troubleService} from "@/global/api/gen";
import {TroubleKeys} from "@/modules/trouble/shared/services/trouble.keys";

export const apiAisStatus = () => {
    return useCustomQuery({
        queryFn: () => troubleService.troubleControllerAisStatus()
            .then((res) => res.data),
        queryKey: TroubleKeys.ais()
    });
};